import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import apiClient from '../../api/apiClient';

/**
 * For "/" only: redirect to dashboard if logged in, else to login.
 * Keeps intended destination in state so login can redirect back after auth.
 */
export default function AuthGate() {
  const location = useLocation();
  const isAuthenticated = apiClient.isAuthenticated();

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }
  return <Navigate to="/login" replace state={{ from: location }} />;
}
